import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Box, ListItem, UnorderedList } from "@chakra-ui/react";
import Link from "components/Shared/Link";
import { PRICING_PAGE } from "utils/config";
import { formatInteger } from "utils/formatting";
import {
  BRAND_QUOTA_DISPLAY_ORDER,
  BRAND_QUOTA_ENTITY_LABELS,
  type QuotaLimitsAccessPlanFragment,
  getQuotaLimits,
} from "utils/quotas";

function formatQuotaLimit(limit: number | null | undefined) {
  if (limit === null) return "Unlimited";

  return formatInteger(limit);
}

type Props = {
  accessPlan: QuotaLimitsAccessPlanFragment;
};

export default function PlanCardQuotaList({
  accessPlan: accessPlanFragmentRef,
}: Props) {
  const quotaLimits = getQuotaLimits(accessPlanFragmentRef);

  return (
    <UnorderedList
      sx={{
        "li::marker": {
          color: "var(--chakra-colors-gray-500)",
        },
      }}
    >
      {BRAND_QUOTA_DISPLAY_ORDER.map((quota) => {
        const label = BRAND_QUOTA_ENTITY_LABELS[quota].plural;
        const limit = quotaLimits[quota];

        return (
          <ListItem
            key={quota}
            color="gray.600"
            fontSize="xs"
            lineHeight="short"
          >
            <Box
              as="span"
              className="use-tabular-nums"
              color="gray.700"
              fontWeight={700}
              sx={{
                "&.use-tabular-nums": {
                  fontVariantNumeric: "tabular-nums",
                },
              }}
            >
              {formatQuotaLimit(limit)}
            </Box>{" "}
            <Box as="span">{label}</Box>
          </ListItem>
        );
      })}

      <ListItem color="gray.600" fontSize="xs" lineHeight="short">
        <Link href={PRICING_PAGE} isExternal fontWeight={400}>
          and more <ExternalLinkIcon />
        </Link>
      </ListItem>
    </UnorderedList>
  );
}
